function scrollBehavior() {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}

function resetScrollTop() {
  const root = document.documentElement;
  const previousBehavior = root.style.scrollBehavior;

  root.style.scrollBehavior = 'auto';
  root.scrollTop = 0;
  document.body.scrollTop = 0;
  window.scrollTo({ behavior: 'auto', left: 0, top: 0 });
  root.style.scrollBehavior = previousBehavior;
}

export function scrollToLocation(hash) {
  if (hash) {
    const behavior = scrollBehavior();
    const id = decodeURIComponent(hash.slice(1));
    const frame = requestAnimationFrame(() => document.getElementById(id)?.scrollIntoView({ behavior, block: 'start' }));
    return () => cancelAnimationFrame(frame);
  }

  resetScrollTop();
  const frame = requestAnimationFrame(resetScrollTop);
  return () => cancelAnimationFrame(frame);
}
